




























    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import appconst from '@/lib/appconst';
    import Enums from '@/lib/enums'
    class AddBaseCost {
        id: number;
        logisticsNumber: string;
        packageNums: number;
    }
    @Component
    export default class CreateBaseCostModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        storecost: AddBaseCost = new AddBaseCost();
        addLoding = false;
        created() {

        }
        signFor() {
            this.save();
        }
        save() {
            (this.$refs.settingcostForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.storecost.id = this.$store.state.frontstock.id;
                    this.addLoding = true;
                    await this.$store.dispatch({
                        type: 'frontstock/supplementStockInfo',
                        data: this.storecost
                    }).finally(() => {
                        this.addLoding = false;
                    });
                    (this.$refs.settingcostForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }


        cancel() {
            (this.$refs.settingcostForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
            }
        }
        costRule = {
            logisticsNumber: [
                { required: true, message: '国内物流单号不能为空', trigger: 'blur' }
            ],
            packageNums: [
                { required: true, message: '打包件数不能为空', trigger: 'blur' }
            ],
        };

    }
